import { ITrackingParams } from './tracking/tracking-params.model';

export interface ILink {
    title: string;
    /** Optional: label-only links (e.g. a submenu toggle) have no target. */
    href?: string;
    target?: string;
    rel?: string;
    id?: string;
    anchor?: string;
    noRouting?: boolean;
    tracking?: ITrackingParams;
    isFile?: boolean;
}

/**
 * Sentinel value used as the default for `[link]` inputs on card components
 * (and anywhere else a component needs a guaranteed-defined `ILink` instance
 * before a real link is provided). Treat as read-only — do not mutate.
 */
export const EMPTY_LINK: ILink = { title: '', href: '' };
